import React, { useContext, useEffect, useState } from "react";

import "../styles/SiteContacts.css";

import { SITE_URL } from "../serverConfig";
import { RestContext } from "../App";
import { Label } from "reactstrap";

const opTypes = {
    "Primary Operator": 1,
    "Secondary Operator": 2,
    Contact: 3,
};

function SiteContacts({ selectedSite }) {
    const [contacts, setContacts] = useState([]);
    const [projectInfo, setProjectInfo] = useState();
    const [loggers, setLoggers] = useState([]);

    const { sendGetRequest } = useContext(RestContext);

    useEffect(() => {
        if (selectedSite && selectedSite.idNo !== "all") {
            sendGetRequest(
                SITE_URL + "/contacts/" + selectedSite.idNo,
                (response) => {
                    setContacts(
                        response.data.contacts?.sort(sortContacts) || []
                    );
                    setProjectInfo({
                        projectAbbr: response.data.projectAbbr,
                        managerName: response.data.managerName,
                        managerEmail: response.data.managerEmail,
                        managerPhone: response.data.managerPhone,
                    });
                    setLoggers(response.data.loggers);
                }
            );
        }
    }, [selectedSite]);

    const sortContacts = (a, b) => {
        if (opTypes[a.opType] < opTypes[b.opType]) return -1;
        else if (opTypes[a.opType] > opTypes[b.opType]) return 1;
        else {
            if (a.admin && !b.admin) return -1;
            else if (b.admin && !a.admin) return 1;
            else {
                return a.name.localeCompare(b.name);
            }
        }
    };

    const getAvailableContactTypes = (contact) => {
        const contactTypes = {
            Email: formatEmail(contact.email),
            Office: formatPhone(contact.office),
            Cell: formatPhone(contact.cell),
            Notes: contact.notes,
        };

        return Object.keys(contactTypes).map((type) => {
            if (!contactTypes[type] || contactTypes[type] === "") return null;
            return (
                <div className="site-contacts-table-row-contact">
                    <span className="site-contacts-table-row-contact-type">
                        {type + ":"}
                    </span>
                    <span className="site-contacts-table-row-contact-value">
                        {contactTypes[type]}
                    </span>
                </div>
            );
        });
    };

    const formatEmail = (email) => {
        if (!email) return null;
        return <a href={"mailto:" + email}>{email}</a>;
    };

    const formatPhone = (phone) => {
        if (!phone) return null;
        const phoneString = phone.replace(/[\.]/g, "-");
        const callable = phoneString.replace(" ", "").replace("x", ",");
        return <a href={"tel:" + callable}>{phoneString}</a>;
    };

    const getProject = () => {
        if (!projectInfo?.projectAbbr) return null;
        const sectionHeader = (
            <tr className="site-contacts-table-section-header">
                <td>Project</td>
                <td>Manager</td>
            </tr>
        );
        const rows = [sectionHeader];
        const phoneString = projectInfo.managerPhone?.replace(/[\.]/g, "-") || null;
        const callable = phoneString?.replace(" ", "").replace("x", ",") || null;
        const projectRow = (
            <tr className="site-contacts-table-row">
                <td className="site-contacts-table-row-name">
                    {projectInfo.projectAbbr}
                </td>
                <td className="site-contacts-table-row-info">
                    <div id="site-contacts-project-manager-name">
                        {projectInfo?.managerName || ""}
                    </div>
                    <div
                        id="site-contacts-project-manager-email"
                        hidden={!projectInfo?.managerEmail}
                    >
                        <a href={"mailto:"+projectInfo.managerEmail}>{projectInfo.managerEmail || ""}</a>
                    </div>
                    <div
                        id="site-contacts-project-manager-phone"
                        hidden={!projectInfo?.managerPhone}
                    >
                        <a href={"tel:"+callable}>{phoneString}</a>
                    </div>
                </td>
            </tr>
        );
        rows.push(projectRow);
        return rows;
    };

    const getPrimary = () => {
        const primaryContacts = contacts.filter(
            (contact) => contact.opType === "Primary Operator"
        );
        if (primaryContacts.length === 0) return null;
        else {
            const sectionHeader = (
                <tr className="site-contacts-table-section-header">
                    <td colSpan={2}>Primary Operators</td>
                </tr>
            );
            const rows = [sectionHeader];
            primaryContacts.forEach((contact) => {
                const row = (
                    <tr className="site-contacts-table-row">
                        <td className="site-contacts-table-row-name">
                            {contact.name + (contact.admin ? "*" : "")}
                        </td>
                        <td className="site-contacts-table-row-info">
                            {getAvailableContactTypes(contact)}
                        </td>
                    </tr>
                );
                rows.push(row);
            });
            return rows;
        }
    };

    const getSecondaryOps = () => {
        const primaryContacts = contacts.filter(
            (contact) => contact.opType === "Secondary Operator"
        );
        if (primaryContacts.length === 0) return null;
        else {
            const sectionHeader = (
                <tr className="site-contacts-table-section-header">
                    <td colSpan={2}>Secondary Operators</td>
                </tr>
            );
            const rows = [sectionHeader];
            primaryContacts.forEach((contact) => {
                const row = (
                    <tr className="site-contacts-table-row">
                        <td className="site-contacts-table-row-name">
                            {contact.name + (contact.admin ? "*" : "")}
                        </td>
                        <td className="site-contacts-table-row-info">
                            {getAvailableContactTypes(contact)}
                        </td>
                    </tr>
                );
                rows.push(row);
            });
            return rows;
        }
    };

    const getOtherContacts = () => {
        const primaryContacts = contacts.filter(
            (contact) => contact.opType === "Contact"
        );
        if (primaryContacts.length === 0) return null;
        else {
            const sectionHeader = (
                <tr className="site-contacts-table-section-header">
                    <td colSpan={2}>Other Contacts</td>
                </tr>
            );
            const rows = [sectionHeader];
            primaryContacts.forEach((contact) => {
                const row = (
                    <tr className="site-contacts-table-row">
                        <td className="site-contacts-table-row-name">
                            {contact.name + (contact.admin ? "*" : "")}
                        </td>
                        <td className="site-contacts-table-row-info">
                            {getAvailableContactTypes(contact)}
                        </td>
                    </tr>
                );
                rows.push(row);
            });
            return rows;
        }
    };

    const getPolling = () => {
        if (!loggers) return null;
        const sectionHeader = (
            <tr className="site-contacts-table-section-header">
                <td>Logger</td>
                <td>IP</td>
            </tr>
        );
        const rows = [sectionHeader];
        loggers.forEach((logger) => {
            const row = (
                <tr className="site-contacts-table-row">
                    <td className="site-contacts-table-row-name">
                        {logger.loggerId || ""}
                    </td>
                    <td className="site-contacts-table-row-info">
                        {logger.ip}
                    </td>
                </tr>
            );
            rows.push(row);
        });
        return rows;
    }

    return (
        <div id="site-contacts">
            <table>
                <tbody>
                    {getProject()}
                    {getPrimary()}
                    {getSecondaryOps()}
                    {getOtherContacts()}
                    {getPolling()}
                    {!contacts || contacts.length === 0 ? <NoContacts /> : null}
                </tbody>
            </table>
            <div id="site-contacts-legend">
                <div hidden={!contacts.some((contact) => contact.admin)}>
                    * Administrative Contact
                </div>
            </div>
        </div>
    );
}

function NoContacts() {
    return (
        <tr id="site-contacts-no-contacts">
            <td colSpan={2}>No contacts found.</td>
        </tr>
    );
}

export default SiteContacts;
